import type { PostHog } from "posthog-js";

let posthogInstance: PostHog | null = null;

export const setPostHogInstance = (instance: PostHog) => {
	posthogInstance = instance;
};

export const captureException = (
	error: Error,
	context?: Record<string, unknown>
) => {
	if (!posthogInstance) return;

	posthogInstance.capture("$exception", {
		$exception_message: error.message,
		$exception_type: error.name,
		$exception_stack_trace_raw: error.stack,
		...context,
	});
};
